import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'
import { CommonSeriesSettings, Label, Series } from 'devextreme-react/chart'

export const PageDurationChart: React.FunctionComponent = ({ }) => {
    return (
        <BPMChart title='Top Page Durations' subTitle='In Seconds' type='bar'
            onRequestLoad={(options, signal) => BPMAnalyticsAPI.getv2<any>(`views/duration`, options, signal)}
        >
            <Series name='AVG Seconds Visited'>
                <Label format={{ type: 'second' }} />
            </Series>

            <CommonSeriesSettings
                type={'bar'}
                valueField="average_time_spent_seconds"

                argumentField="name">

            </CommonSeriesSettings>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Product/Pages/charts/PageDurationChart.tsx